import { CONTACT_EMAIL, SUPPORT_EMAIL } from 'src/config';

export const FaqData = [
    {
        header: 'faq.sections.about',
        entries: [
            {
                key: '1',
                title: 'faq.entries.1.title',
                content: 'faq.entries.1.content',
            },
            {
                key: '2',
                title: 'faq.entries.2.title',
                content: 'faq.entries.2.content',
            },
            {
                key: '3',
                title: 'faq.entries.3.title',
                content: 'faq.entries.3.content',
            },
            {
                key: '4',
                title: 'faq.entries.4.title',
                content: 'faq.entries.4.content',
                contact: CONTACT_EMAIL,
            },
            {
                key: '5',
                title: 'faq.entries.5.title',
                content: 'faq.entries.5.content',
            },
        ],
    },
    {
        header: 'faq.sections.terms',
        entries: [
            {
                key: '6',
                title: 'faq.entries.6.title',
                content: 'faq.entries.6.content',
            },
            {
                key: '7',
                title: 'faq.entries.7.title',
                content: 'faq.entries.7.content',
            },
            {
                key: '8',
                title: 'faq.entries.8.title',
                content: 'faq.entries.8.content',
            },
            {
                key: '9',
                title: 'faq.entries.9.title',
                content: 'faq.entries.9.content',
            },
            {
                key: '10',
                title: 'faq.entries.10.title',
                content: 'faq.entries.10.content',
            },
            {
                key: '11',
                title: 'faq.entries.11.title',
                content: 'faq.entries.11.content',
            },
            {
                key: '12',
                title: 'faq.entries.12.title',
                content: 'faq.entries.12.content',
            },
        ],
    },
    {
        header: 'faq.sections.guide',
        entries: [
            {
                key: '14',
                title: 'faq.entries.14.title',
                content: 'faq.entries.14.content',
            },
            {
                key: '15',
                title: 'faq.entries.15.title',
                content: 'faq.entries.15.content',
                contact: CONTACT_EMAIL,
            },
            {
                key: '16',
                title: 'faq.entries.16.title',
                content: 'faq.entries.16.content',
                contact: CONTACT_EMAIL,
            },
            {
                key: '17',
                title: 'faq.entries.17.title',
                content: 'faq.entries.17.content',
            },
            {
                key: '18',
                title: 'faq.entries.18.title',
                content: 'faq.entries.18.content',
                contact: CONTACT_EMAIL,
            },
            {
                key: '19',
                title: 'faq.entries.19.title',
                content: 'faq.entries.19.content',
            },
            {
                key: '20',
                title: 'faq.entries.20.title',
                content: 'faq.entries.20.content',
            },
            {
                key: '21',
                title: 'faq.entries.21.title',
                content: 'faq.entries.21.content',
            },
            {
                key: '22',
                title: 'faq.entries.22.title',
                content: 'faq.entries.22.content',
            },
            {
                key: '23',
                title: 'faq.entries.23.title',
                content: 'faq.entries.23.content',
            },
            {
                key: '24',
                title: 'faq.entries.24.title',
                content: 'faq.entries.24.content',
            },
            {
                key: '25',
                title: 'faq.entries.25.title',
                content: 'faq.entries.25.content',
            },
            {
                key: '26',
                title: 'faq.entries.26.title',
                content: 'faq.entries.26.content',
            },
            {
                key: '27',
                title: 'faq.entries.27.title',
                content: 'faq.entries.27.content',
                contact: CONTACT_EMAIL,
            },
            {
                key: '28',
                title: 'faq.entries.28.title',
                content: 'faq.entries.28.content',
                contact: CONTACT_EMAIL,
            },
            {
                key: '29',
                title: 'faq.entries.29.title',
                content: 'faq.entries.29.content',
            },
            {
                key: '30',
                title: 'faq.entries.30.title',
                content: 'faq.entries.30.content',
                readMore: 'https://www.7digital.com',
            },
            {
                key: '31',
                title: 'faq.entries.31.title',
                content: 'faq.entries.31.content',
            },
            {
                key: '32',
                title: 'faq.entries.32.title',
                content: 'faq.entries.32.content',
            },
            {
                key: '33',
                title: 'faq.entries.33.title',
                content: 'faq.entries.33.content',
            },
            {
                key: '34',
                title: 'faq.entries.34.title',
                content: 'faq.entries.34.content',
                contact: SUPPORT_EMAIL,
            },
            {
                key: '35',
                title: 'faq.entries.35.title',
                content: 'faq.entries.35.content',
            },
            {
                key: '36',
                title: 'faq.entries.36.title',
                content: 'faq.entries.36.content',
            },
            {
                key: '37',
                title: 'faq.entries.37.title',
                content: 'faq.entries.37.content',
            },
            {
                key: '38',
                title: 'faq.entries.38.title',
                content: 'faq.entries.38.content',
            },
            {
                key: '39',
                title: 'faq.entries.39.title',
                content: 'faq.entries.39.content',
                contact: CONTACT_EMAIL,
            },
            {
                key: '40',
                title: 'faq.entries.40.title',
                content: 'faq.entries.40.content',
            },
            {
                key: '41',
                title: 'faq.entries.41.title',
                content: 'faq.entries.41.content',
            },
            {
                key: '42',
                title: 'faq.entries.42.title',
                content: 'faq.entries.42.content',
            },
            {
                key: '43',
                title: 'faq.entries.43.title',
                content: 'faq.entries.43.content',
            },
            {
                key: '44',
                title: 'faq.entries.44.title',
                content: 'faq.entries.44.content',
            },
            {
                key: '45',
                title: 'faq.entries.45.title',
                content: 'faq.entries.45.content',
            },
            {
                key: '46',
                title: 'faq.entries.46.title',
                content: 'faq.entries.46.content',
            },
            {
                key: '47',
                title: 'faq.entries.47.title',
                content: 'faq.entries.47.content',
                readMore: 'https://www.mundu.no/privacy',
            },
            {
                key: '48',
                title: 'faq.entries.48.title',
                content: 'faq.entries.48.content',
                readMore: 'https://www.mundu.no/privacy',
            },
            {
                key: '49',
                title: 'faq.entries.49.title',
                content: 'faq.entries.49.content',
                contact: CONTACT_EMAIL,
            },
            {
                key: '50',
                title: 'faq.entries.50.title',
                content: 'faq.entries.50.content',
            },
        ],
    },
    {
        header: 'faq.sections.account',
        entries: [
            {
                key: '51',
                title: 'faq.entries.51.title',
                content: 'faq.entries.51.content',
            },
            {
                key: '52',
                title: 'faq.entries.52.title',
                content: 'faq.entries.52.content',
            },
            {
                key: '53',
                title: 'faq.entries.53.title',
                content: 'faq.entries.53.content',
            },
            {
                key: '54',
                title: 'faq.entries.54.title',
                content: 'faq.entries.54.content',
                contact: SUPPORT_EMAIL,
            },
        ],
    },
];
